import React, { useMemo } from 'react';
import Accordion from "components/Accordion";
import OwnershipDetailsView from "./OwnershipDetailsView";
import { createDeepCopyObj } from 'utils/helperMethods';

const UboDetailsAccordion = ({ transformedData, data, auth, handleCheckerRemarksData, isViewMode, editedFields }) => {
  const uboDetails = useMemo(() => {
    const sourceUBOs = transformedData?.uboDetails || [];
    const fallbackUBOs = data?.uboDetails || [];
  
    const syncedUBOs = [...sourceUBOs];
  
    for (let i = sourceUBOs.length; i < fallbackUBOs.length; i++) {
      syncedUBOs.push(fallbackUBOs[i]);
    }
  
    if (syncedUBOs.length > fallbackUBOs.length) {
      syncedUBOs.length = fallbackUBOs.length;
    }
  
    return createDeepCopyObj(syncedUBOs);
  }, [transformedData?.uboDetails, data?.uboDetails]);
  

    // console.log("transformedData, data, uboDetails", transformedData, data, handleCheckerRemarksData);
  
    // Return the JSX, mapping through uboDetails array to render Accordion components
    return (
      <div>
        {!!uboDetails && uboDetails.map((uboDetailsitem, uboDetailsindex) => (
          <Accordion
            id={`uboDetails-${uboDetailsindex}`}
            key={`uboDetails-${uboDetailsindex}`}
            customClass="rounded-accordion"
            upperComponent={<h3>{`UBO Details ${uboDetailsindex + 1}`}</h3>}
            isOpened
            isArrowIndicator
            lowerComponent={
              <OwnershipDetailsView
                data={data.uboDetails[uboDetailsindex]}
                section={`uboDetails.${uboDetailsindex}`}
                additionalData={uboDetailsitem} // Use actual additionalData here if necessary
                auth={auth}
                handleCheckerRemarksData={handleCheckerRemarksData}
                isViewMode={isViewMode}
                editedFields={editedFields}
              />
            }
          />
        ))}
      </div>
    );
  };
  
  export default UboDetailsAccordion;
  